import React from 'react';
import { uniqueId } from 'lodash';
import PuzzleRemoteMultiselectAllData from '../multiselect/PuzzleRemoteMultiselectAllData';
import PuzzleComboBox from './PuzzleComboBox';
import { PUZZLE_REMOTE_COMBO_ALL_DATA } from './Types';

/**
 * Remote all Data loaded after mounting and uses multiselect virtualization and filtering
 * @author Zarko Radojevic
 */
class PuzzleRemoteComboAllData extends PuzzleRemoteMultiselectAllData<PUZZLE_REMOTE_COMBO_ALL_DATA> {
  constructor(props) {
    super(props);
    this.moduleId = uniqueId('puzzle-combobox_');
  }

  render() {
    const { total, skip } = this.state;
    const { remoteVirtualScrolling } = this.props;
    const { pageSize = 20 } = remoteVirtualScrolling;
    let props = { ...this.props };
    props = {
      ...props,
      data: this.state.subsetData,
      onFilterChange: this.onRemoteVirtualScrollingFilterChange
    };

    if (total > this.virtualizationMoreThen) {
      props = {
        ...props,
        virtual: {
          pageSize,
          total,
          skip
        },
        onPageChange: this.onRemoteVirtualScrollingPageChange
      };
    }

    let popupClass = 'data-preventrecorddeselect';
    if (total < 6) {
      popupClass += ' tp-remote-combo-box-popup';
    }

    return (
      <PuzzleComboBox
        {...props}
        filterable={remoteVirtualScrolling.filterable}
        popupSettings={{
          popupClass
        }}
        ref={(el: any) => {
          this.comboRef = el;
        }}
      />
    );
  }
}

export default PuzzleRemoteComboAllData;
